import { ArrowUpRight } from "lucide-react";
import { createLucideIcon } from "./createLucideIcon";

export const ArrowExternalIcon = createLucideIcon(ArrowUpRight);
